<template>
  <div>
    <v-form v-model="valid" autocomplete="off">
      <v-container>
        <v-row>
          <v-col cols="12">
            <span class="screenHeading">Clone Commnunity</span>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-autocomplete
              :items="communities"
              item-value="communityAbbreviation"
              item-title="communityName"
              label="Select community"
              return-object
              clearable
              required
              variant="underlined"
              :rules="selectedCommunityRules"
              v-model="selectedCommunity"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col class="ma-0">
            <fieldset>
              <legend>Cloned Community Fields</legend>
              <v-row dense justify="center">
                <v-col>
                  <v-text-field
                    label="Community Name"
                    v-model="newCommunity.communityName"
                    :maxlength="maximumTitleLength"
                    :rules="titleRules"
                    variant="underlined"
                    required
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    required
                    v-model="newCommunity.communityAbbreviation"
                    label="Short Name"
                    :rules="shortNameRules"
                    :maxlength="maximumShortNameLength"
                    variant="underlined"
                  ></v-text-field>
                </v-col>
              </v-row>
            </fieldset>
          </v-col>
        </v-row>
        <v-card v-if="fullCommunity.id">
          <v-container>
            <v-row dense>
              <v-col>
                <h3 class="mb-2">{{ fullCommunity.communityName }} ({{ fullCommunity.communityAbbreviation }})</h3>
                <div class="mb-2">
                  <strong>Community hidden from all users except Process Manager and IT support?</strong>
                  <div>{{ fullCommunity.testCommunity ? 'Yes' : 'No' }}</div>
                </div>
                <div class="mb-2">
                  <strong>Notifications will be sent from this community?</strong>
                  <div>{{ fullCommunity.allowNotifications ? 'Yes' : 'No' }}</div>
                </div>

                <div class="mb-2">
                  <strong>Notifications overriden?</strong>
                  <div>
                    {{ fullCommunity.overrideNotifications ? 'Yes' : 'No' }}
                    {{ fullCommunity.overrideNotifications ? `(${fullCommunity.overrideNotificationsTo})` : '' }}
                  </div>
                </div>
                <div v-if="fullCommunity.owners && fullCommunity.owners.length" class="mb-2">
                  <strong>Community Owners</strong>
                  <ul style="padding-left: 20px;">
                    <li v-for="owner in fullCommunity.owners || []" :key="owner.id">{{ owner.displayName }}</li>
                  </ul>
                </div>
                <div>
                  <strong>Closers</strong>
                  <ul style="padding-left: 20px;">
                    <li v-for="closer in fullCommunity.closers || []" :key="closer">{{ getRoleName(closer) }}</li>
                  </ul>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span class="item-row">
                  <v-checkbox class="checkbox" v-model="selected.changeTypes" disabled></v-checkbox>
                  <span style="margin-top: 24px;"
                    >Change Types <strong>({{ (fullCommunity.changeTypes || []).length }})</strong></span
                  >
                </span>
                <span class="item-row">
                  <v-checkbox class="checkbox" v-model="selected.mocTypes"></v-checkbox>
                  <span style="margin-top: 24px;"
                    >Moc Types <strong>({{ (fullCommunity.mocTypes || []).length }})</strong></span
                  >
                </span>
                <span class="item-row">
                  <v-checkbox class="checkbox" v-model="selected.changeCategories"></v-checkbox>
                  <span style="margin-top: 24px;"
                    >Change Categories <strong>({{ (fullCommunity.changeCategories || []).length }})</strong></span
                  >
                </span>
                <span class="item-row">
                  <v-checkbox class="checkbox" v-model="selected.approvalProcessTypes"></v-checkbox>
                  <span style="margin-top: 24px;"
                    >Approval Process Types <strong>({{ approvalProcessTypes.length }})</strong></span
                  >
                </span>
                <span class="item-row">
                  <v-checkbox class="checkbox" v-model="selected.changeCategoryMocTypes"></v-checkbox>
                  <span style="margin-top: 24px;"
                    >Change Categories Moc Types <strong>({{ changeCategoryMocTypes.length }})</strong></span
                  >
                </span>
                <span class="item-row">
                  <v-checkbox class="checkbox" v-model="selected.tasks"></v-checkbox>
                  <span style="margin-top: 24px;"
                    >Tasks <strong>({{ (fullCommunity.tasks || []).length }})</strong></span
                  >
                </span>
                <span class="item-row">
                  <v-checkbox class="checkbox" v-model="selected.helpfulLinks"></v-checkbox>
                  <span style="margin-top: 24px;"
                    >Helpful Links <strong>({{ (fullCommunity.helpfulLinks || []).length }})</strong></span
                  >
                </span>
                <span class="item-row">
                  <v-checkbox class="checkbox" v-model="selected.qa"></v-checkbox>
                  <span style="margin-top: 24px;"
                    >Fields and Responses <strong>({{ allQuestionsAnswers.length }})</strong></span
                  >
                </span>
                <span class="item-row">
                  <v-checkbox class="checkbox" v-model="selected.relationships"></v-checkbox>
                  <span style="margin-top: 24px;"
                    >Responses Relationships <strong>({{ (fullCommunity.qaRelationships || []).length }})</strong></span
                  >
                </span>
                <span class="item-row">
                  <v-checkbox class="checkbox" v-model="selected.displayNames"></v-checkbox>
                  <span style="margin-top: 24px;">Display Names</span>
                </span>
                <span class="item-row">
                  <v-checkbox class="checkbox" v-model="selected.emailTemplates"></v-checkbox>
                  <span style="margin-top: 24px;">Email Templates</span>
                </span>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <v-row>
          <v-col cols="12" sm="10">
            <v-btn
              color="success"
              :disabled="!valid || !selectedItems.length"
              type="button"
              @click="showConfirmationDialog = true"
              >Clone</v-btn
            >
            <v-btn type="button" class="ml-3" @click="showCancelDialog = true">Cancel</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-dialog persistent v-model="showConfirmationDialog" max-width="500">
      <v-card v-if="showConfirmationDialog">
        <v-container>
          <h3>Are you sure you want to proceed with these changes ?</h3>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="red" text @click="clone">Yes</v-btn>
            <v-btn color="black" text @click="showConfirmationDialog = false">No</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="showCancelDialog" max-width="500">
      <v-card v-if="showCancelDialog">
        <v-container>
          <h3>Are you sure you want to cancel ?</h3>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="red" text @click="cancelChanges">Yes</v-btn>
            <v-btn color="black" text @click="showCancelDialog = false">No</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <v-overlay v-model="loading" class="align-center justify-center">
      <v-card color="primary" dark width="300">
        <v-card-text>
          Loading...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-overlay>
    <toaster ref="toaster"></toaster>
  </div>
</template>

<script>
import MOCAdminService from '@/services/admin.service'
import Toaster from '@/components/Toaster'
import { Roles } from '@/common'

export default {
  name: 'CommunityClone',
  components: {
    Toaster
  },
  data() {
    return {
      loading: true,
      communities: [],
      showConfirmationDialog: false,
      showCancelDialog: false,
      selectedCommunityRules: [(newValue) => (!newValue ? 'This field is required' : true)],
      maximumTitleLength: 60,
      minimumTitleLength: 3,
      maximumShortNameLength: 3,
      minimumShortNameLength: 3,
      newCommunity: {
        communityAbbreviation: '',
        communityName: ''
      },
      valid: false,
      selectedCommunity: null,
      fullCommunity: {},
      roles: Object.values(Roles.properties),
      allQuestionsAnswers: [],
      selected: {
        changeTypes: true,
        mocTypes: true,
        changeCategories: true,
        approvalProcessTypes: true,
        changeCategoryMocTypes: true,
        tasks: true,
        helpfulLinks: true,
        qa: true,
        relationships: true,
        displayNames: true,
        emailTemplates: true
      }
    }
  },
  computed: {
    titleRules() {
      return [
        (v) => !!v || 'Title is required',
        (v) => (v && v.length >= this.minimumTitleLength) || `Minimum length is ${this.minimumTitleLength}`,
        (v) => (v && v.length <= this.maximumTitleLength) || `Maximum length is ${this.maximumTitleLength}`
      ]
    },
    shortNameRules() {
      return [
        (v) => !!v || 'Short Name is required',
        (v) => (v && v.trim().length === this.minimumShortNameLength) || `Length must be ${this.minimumShortNameLength}`,
        (v) => (v && !this.isValidAbbreviation(v)) || `Valid characters are A-Z, a-z, 0-9 or _`
      ]
    },
    approvalProcessTypes() {
      return (this.fullCommunity.changeCategories || []).reduce((acc, cur) => {
        acc = acc.concat(cur.approvalProcessTypes)
        return acc
      }, [])
    },
    changeCategoryMocTypes() {
      return (this.fullCommunity.changeCategories || []).reduce((acc, cur) => {
        acc = acc.concat(cur.mocTypes)
        return acc
      }, [])
    },
    selectedItems() {
      return Object.keys(this.selected).filter((k) => this.selected[k])
    }
  },
  methods: {
    getRoleName(key) {
      const role = this.roles.find((r) => r.value === key)
      return role ? role.name : ''
    },
    getQA() {
      this.allQuestionsAnswers = (this.fullCommunity.questions || []).reduce((acc, cur) => {
        const result = this.getQuestionsFromAnswers(cur, cur.values)
        return acc.concat(result)
      }, [])
    },
    getQuestionsFromAnswers(root = {}, values = []) {
      if (!values.length) {
        return [{}]
      }
      return values.reduce((a, c) => {
        a = a.concat({
          ...c
        })
        for (let cur of c.questions) {
          a = a.concat(this.getQuestionsFromAnswers(root, cur.values))
        }
        return a
      }, [])
    },
    isValidAbbreviation(abbreviation) {
      var patt = new RegExp('[^A-Za-z0-9_]+')
      var res = patt.test(abbreviation)
      return res
    },
    clone() {
      if (this.loading) return
      this.showConfirmationDialog = false
      this.loading = true
      MOCAdminService.cloneCommunity(
        {
          communityAbbreviation: this.selectedCommunity.communityAbbreviation,
          newCommunityName: this.newCommunity.communityName,
          newCommunityAbbreviation: this.newCommunity.communityAbbreviation
        },
        this.selectedItems
      )
        .then(() => {
          this.$refs.toaster.pop(
            'success',
            `Community ${this.selectedCommunity.communityAbbreviation} successfully cloned in ${this.newCommunity.communityAbbreviation}`
          )
          this.newCommunity = {}
          this.selectedCommunity = null
        })
        .catch((err) => {
          this.$refs.toaster.pop('error', err.response.data.message ? err.response.data.message : 'Clone failed')
        })
        .finally(() => {
          this.loading = false
        })
    },
    cancelChanges() {
      this.newCommunity = {}
      this.selectedCommunity = null
      this.showCancelDialog = false
    },
    loadSelectedCommunity(communityAbbreviation) {
      if (this.loading) return
      this.loading = true
      MOCAdminService.getCommunity(communityAbbreviation)
        .then((res) => (this.fullCommunity = res))
        .then(this.getQA)
        .catch((err) => {
          console.log(err)
          switch (err.response.status) {
            case 401:
              this.$refs.toaster.pop('error', 'You are unauthorized to view this community')
              break
            default:
              this.$refs.toaster.pop('error', 'Failed to retrieve data')
          }
        })
        .finally(() => (this.loading = false))
    }
  },
  watch: {
    selectedCommunity(newValue) {
      this.fullCommunity = {}
      if (!newValue) return newValue
      this.loadSelectedCommunity(newValue.communityAbbreviation)
    }
  },
  created() {
    MOCAdminService.getCommunity()
      .then((succ) => (this.communities = succ))
      .catch(() => {})
      .finally(() => (this.loading = false))
  }
}
</script>
<style scoped>
.item-row {
  display: flex;
  align-items: center;
}

.item-row .checkbox {
  margin-top: 0px;
  margin-bottom: 0;
  height: 32px;
}

.v-dialog__container {
  display: unset;
}
</style>
